export default __webpack_public_path__ + "_/images/landing-affiliates/egb-grey-691c653f95168cc047f3d813137bcb0990d01885c6e2ecee5288ce2f44ea1391.svg";